import React from 'react';
import cn from 'classnames';
import {
  Section as ElementSection,
  FormSection,
  ListInfo,
  Title,
} from 'views/pages/ClientDetail/components/Elements';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import { DRIVER_QUERY_OBJ_KEYS } from '../../constants';
import classes from './Section.module.scss';

const DriverQuery = ({ className, isEdit, form, data }) => {
  return (
    <div className={cn(classes.driverQuerySection, className)}>
      <Title text="Driver Query" />
      <ElementSection className={classes.elSection}>
        {isEdit ? (
          <FormSection>
            <InputItem
              name={'dq_current_year'}
              label="Driver Query Current Year"
              form={form}
              type="file"
            />
            <InputItem
              name={'dq_expiration_date'}
              label="Expiration Date"
              form={form}
              type="date"
            />
            <InputItem
              name={'dq_previous_years'}
              label="Driver Query Previous Years"
              form={form}
              type="file"
              multiple
            />
          </FormSection>
        ) : (
          <ListInfo objKeys={DRIVER_QUERY_OBJ_KEYS} data={data} />
        )}
      </ElementSection>
    </div>
  );
};

export default DriverQuery;
